<template>
  <div>
    <v-dialog
      :close-on-content-click="false"
      v-model="showSectionCreator"
      :fullscreen="$vuetify.breakpoint.xs"
      max-width="1864px"
    >
      <SectionCreator
        @close-section-creator="showSectionCreator = false;"
      />
    </v-dialog>
    <span
      v-if="sections.length > 0 || showAddSection"
      class="tree-title"
    >
      {{ title }}
    </span>
    <div
      v-for="block in sections"
      :key="block.id"
      class="pl-3"
      :class="block.focused ? 'focusTableEntry' : 'unfocusTableEntry'"
    >
      <div
        @click="selectSection(block)"
        class="py-2 ml-5 tableEntry"
      >
        {{ block.title }}
      </div>
    </div>
    <div>
      <v-btn
        outlined
        small
        color="primary"
        class="mt-2 ml-3"
        @click.exact.stop.prevent="addSection()"
        v-if="showAddSection"
      >
        {{ $t('views.journal.sections.addSection') }}
      </v-btn>
    </div>
  </div>
</template>
<script>
import SectionCreator from './journal/SectionCreator';

export default {
  name: 'JournalSectionsTreeItems',
  components: {
    SectionCreator,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    sections: {
      type: Array,
      required: true,
    },
    showAddSection: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showSectionCreator: false,
  }),
  methods: {
    selectSection(section) {
      section.select();
    },
    addSection() {
      this.showSectionCreator = !this.showSectionCreator;
    },
  },
};
</script>
<style scoped>
.tableEntry {
  display: block;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}
.focusTableEntry {
  color: white;
  background-color: #3C44C8;
  border-radius: 25px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.unfocusTableEntry {
  color: #232137;
}
.tree-title {
  margin-left: 12px;
  line-height: 28px;
  font-weight: 600;
  font-size: 18px;
}
</style>
